import { Pagination } from '@malesia/react-components/dist/src/components/Pagination';
import { TableFooter } from '@malesia/react-components/dist/src/components/Table/TableFooter';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectPagination, selectList } from '../store/selectors';
import { actions } from '../store/slice';

export const ReservationInvoiceListFooterWithStore = () => {
    const dispatch = useDispatch();
    const reservationList = useSelector(selectList);
    const pagination = useSelector(selectPagination);

    return (
        <TableFooter
            paginationSlot={
                <Pagination
                    total={reservationList.total}
                    pageTotal={reservationList.items.length}
                    pagination={pagination}
                    maxPageSize={50}
                    setPage={(data) => {
                        dispatch(actions.setPage(data));
                    }}
                    setPageSize={(data) => {
                        dispatch(actions.setPageSize(data));
                    }}
                />
            }
        />
    );
};
